import { Provider } from '@angular/core';
import {
  MCAuthoritiesEventsAgriculture,
  MCAuthoritiesEventsAntiquities,
  MCAuthoritiesEventsAntiquitiesUtils,
  MCAuthoritiesEventsCivilAdministration,
  MCAuthoritiesEventsCommunication,
  MCAuthoritiesEventsCountries,
  MCAuthoritiesEventsEconomy,
  MCAuthoritiesEventsEconomyUtils,
  MCAuthoritiesEventsEnvironment,
  MCAuthoritiesEventsHealth,
  MCAuthoritiesEventsManufacturers,
  MCAuthoritiesEventsModelCode,
  MCAuthoritiesEventsResponseReadiness,
  MCAuthoritiesEventsTabs,
  MCAuthoritiesEventsTransportation,
  MCAuthoritiesFieldUtils,
  MCPersonalVehicleImportService,
  MCPersonalVehicleImportUtils,
  MCTotalUnitPrice,
} from '@maslul/common-services';
import { TotalUnitPrice } from '../services/authorities/common/total-unit-price';
import { AuthoritiesEventsAgriculture } from '../services/authorities/events/agriculture/service';
import { AuthoritiesEventsAntiquities } from '../services/authorities/events/antiquities/service';
import { AuthoritiesEventsAntiquitiesUtils } from '../services/authorities/events/antiquities/utils';
import { MIAuthoritiesEventsCivilAdministration } from '../services/authorities/events/civil-administration/service';
import { AuthoritiesEventsCountries } from '../services/authorities/events/common/countries';
import { AuthoritiesFieldUtils } from '../services/authorities/events/common/field-utils';
import { AuthoritiesEventsManufacturers } from '../services/authorities/events/common/manufacturers';
import { AuthoritiesEventsModelCode } from '../services/authorities/events/common/model-code';
import { AuthoritiesEventsResponseReadiness } from '../services/authorities/events/common/response-readiness';
import { AuthoritiesEventsCommunication } from '../services/authorities/events/communication/service';
import { AuthoritiesEventsEconomy } from '../services/authorities/events/economy/service';
import { AuthoritiesEventsEconomyUtils } from '../services/authorities/events/economy/utils';
import { AuthoritiesEventsEnvironment } from '../services/authorities/events/environment/service';
import { AuthoritiesEventsHealth } from '../services/authorities/events/health/service';
import { AuthoritiesEventsTransportation } from '../services/authorities/events/transportation/service';
import { PersonalVehicleImportUtils } from '../services/authorities/events/transportation/personal-vehicle-import.utils';
import { PersonalVehicleImportService } from '../services/authorities/events/transportation/personal-vehicle-import.service';
import { AuthoritiesEventsTabs } from '../services/authorities/events/common/tab';

export const AUTHORITIES_PROVIDERS: Provider[] = [
  {
    provide: MCAuthoritiesEventsAntiquitiesUtils,
    useClass: AuthoritiesEventsAntiquitiesUtils,
  },
  { provide: MCAuthoritiesEventsEconomy, useClass: AuthoritiesEventsEconomy },
  {
    provide: MCAuthoritiesEventsEconomyUtils,
    useExisting: AuthoritiesEventsEconomyUtils,
  },
  {
    provide: MCAuthoritiesEventsCountries,
    useClass: AuthoritiesEventsCountries,
  },
  {
    provide: MCAuthoritiesEventsManufacturers,
    useClass: AuthoritiesEventsManufacturers,
  },
  {
    provide: MCAuthoritiesEventsModelCode,
    useClass: AuthoritiesEventsModelCode,
  },
  {
    provide: MCAuthoritiesEventsResponseReadiness,
    useClass: AuthoritiesEventsResponseReadiness,
  },
  {
    provide: MCAuthoritiesEventsCommunication,
    useClass: AuthoritiesEventsCommunication,
  },
  {
    provide: MCAuthoritiesEventsTransportation,
    useClass: AuthoritiesEventsTransportation,
  },
  {
    provide: MCAuthoritiesEventsAgriculture,
    useClass: AuthoritiesEventsAgriculture,
  },
  { provide: MCAuthoritiesEventsHealth, useClass: AuthoritiesEventsHealth },
  {
    provide: MCAuthoritiesEventsEnvironment,
    useClass: AuthoritiesEventsEnvironment,
  },
  {
    provide: MCAuthoritiesEventsAntiquities,
    useClass: AuthoritiesEventsAntiquities,
  },
  {
    provide: MCAuthoritiesEventsCivilAdministration,
    useClass: MIAuthoritiesEventsCivilAdministration,
  },
  { provide: MCAuthoritiesFieldUtils, useExisting: AuthoritiesFieldUtils },
  { provide: MCTotalUnitPrice, useClass: TotalUnitPrice },
  {
    provide: MCPersonalVehicleImportUtils,
    useExisting: PersonalVehicleImportUtils,
  },
  {
    provide: MCPersonalVehicleImportService,
    useExisting: PersonalVehicleImportService,
  },
  { provide: MCAuthoritiesEventsTabs, useExisting: AuthoritiesEventsTabs },
];
